import i18n from 'i18next';
import { registerValidator } from 'core/forms';

import getIsDateTrigger from '../helpers/getIsDateTrigger';

import isPositiveInteger from '@/forms/validators/isPositiveInteger';

const isTimingValidBasedOnTrigger = ({ fieldValue, model }) => ({
  error: i18n.t('error-required-field-error'),
  hasError: getIsDateTrigger(model)
    ? isPositiveInteger({ fieldValue }).hasError
    : fieldValue === 1,
  isRequired: true,
});

registerValidator('isTimingValidBasedOnTrigger', isTimingValidBasedOnTrigger);

export default isTimingValidBasedOnTrigger;
